/**
 * B-new-44 PR-2 — 2FA challenge route configuration.
 *
 * Currently DEAD CODE: BetterAuth's redirect strategy is not yet wired
 * to point here (that lands in PR-1, `apps/api/src/lib/auth.ts` — see
 * `docs/04-development/B-NEW-44-2FA-CHALLENGE-DESIGN.md`). Shipped first
 * so the redirect target exists BEFORE the switch is flipped in PR-1.
 * That corrects the design doc's original PR-1-then-PR-2 order, which
 * would have stranded any 2FA-enrolled user in a 404 during the gap.
 *
 * Search params:
 *   - `state` — opaque continuation token BetterAuth's twoFactor plugin
 *     issues with its verification cookie. The component passes it back
 *     on the verify request. Optional here (undefined during dead-code
 *     phase; will always be set post-PR-1).
 */

import { createFileRoute, redirect } from '@tanstack/react-router'

const SUPPORTED_LOCALES = ['es', 'gl', 'en', 'de', 'fr', 'it', 'nl', 'pt']

export const Route = createFileRoute('/$locale/2fa-challenge')({
  beforeLoad: ({ params }) => {
    // Guard: if $locale isn't a real locale (someone visits /2fa-challenge
    // directly and TanStack Router matches $locale='2fa-challenge'),
    // redirect to /en/2fa-challenge. Mirrors sign-in.tsx pattern.
    if (!SUPPORTED_LOCALES.includes(params.locale)) {
      throw redirect({
        to: '/$locale/2fa-challenge',
        params: { locale: 'en' },
        search: { state: undefined },
      })
    }
  },
  validateSearch: (s: Record<string, unknown>) => ({
    ...(typeof s.state === 'string' ? { state: s.state } : {}),
  }),
})
